<template>
	<div>
		<!-- <a class="btn btn-xs btn-info" @click="doUpdate" :disabled="loading_doUpdate">Применить обновление</a>  -->
		
		<div class="form-inline form-group">
			<label class="control-label">Статус:</label>&nbsp; 
			<select v-model="$data.statusValue" @change="doStatusChange" :disabled="loading_doStatusChange" class="form-control">
				<option :value="1" style="color: green;">Включена</option>
				<option :value="2" style="color: red;">Отключена</option>
			</select>
		</div>
		
		<div class="well well-sm">
			<a class="btn btn-xs btn-default btn-block" @click="doRun" :disabled="loading_doRun">Принудительный запуск</a>
			<label class="font-normal"><input type="radio" value="TEST" v-model="doRun_recipientsMode" /> Подписчикам с признаком "Тестовый"</label>
			<br />
			<!-- <label class="font-normal"><input type="radio" value="SPECIFY" v-model="doRun_recipientsMode" /> На указанный адрес</label>
			<br /> -->
			<label class="font-normal"><input type="radio" value="NORMAL" v-model="doRun_recipientsMode" /> Всем получателям</label>
			
			<!-- <input class="form-control" v-model="doRun_urlParams" placeholder="Параметры URL (опц.)" /> фрагмент querystring вида &id=123&myParam=TEST, эти параметры попадут в урлы формирования письма и списка получателей (если тип получателя - 2), здесь можно указать айди рассылаемой записи к примеру -->
		</div>
	</div>
</template>


<script>
	import urlUtil from '@uarm/src/util-url.js'
	//import ctrlMixins from './../_mixins.js'
	import axios from 'axios'

	var baseUrl = urlUtil.mailingContext + '/mailings/';

	export default {
		name: 'spc_mailing_actions',
		//mixins: [ctrlMixins], // c_value, c_ctrlParams, c_srv_options, пропсы view_type, field_meta и так далее
		props: { // большая часть пропсов приезжает из ctrlMixins!
			value: {
				default: ''
			},
			record_data: {}
		},
		data: function(){
			var mailingData = Object.assign({}, this.$props.record_data);
			if (!mailingData.status) {
				console.error('В ответе сервера нет поля status!');
				// поле должно выводиться в список с контролом статик и параметром isInvisible
				// такой костыль
			}
			return {
				baseUrlWithId: baseUrl + this.$props.record_data.ITEM_ID,
				//loading_doUpdate: false,
				loading_doStatusChange: false,
				loading_doRun: false,
				mailingData: mailingData,
				doRun_recipientsMode: 'TEST',
				statusValue: mailingData.status,
			}
		},
		methods: {
			doStatusChange: function() {
				var vm = this;
				vm.$data.loading_doStatusChange = true;				
				var statusDict = {
					1: 'enable',
					2: 'disable',
				}
				var actionCode = statusDict[vm.$data.statusValue];
				axios.post(vm.$data.baseUrlWithId + '?action=' + actionCode)
					.then(function(data){
						// TODO здесь приходит data.status === 'DISABLED'
						// то есть правильно ориентироваться именно на него
						vm.successHandler();
					})
					// TODO здесь надо откатывать значение на предыдущее
					.catch(vm.errorHandler) 
					.then(function() {
						vm.$data.loading_doStatusChange = false;
					});
			},
			doEnable: function(){
				var vm = this;
				vm.$data.loading_doEnable = true;
				axios.post(vm.$data.baseUrlWithId + '?action=enable')
					.then(vm.successHandler)
					.catch(vm.errorHandler)
					.then(function() {
						vm.$data.loading_doEnable = false;
					});
			},
			doRun: function(){
				var vm = this;
				var mode = this.$data.doRun_recipientsMode;
				if (mode === 'SPECIFY') {
					alert('Этот режим пока не поддерживается');
					return
				}
				var actionName = mode === 'NORMAL' ? 'startInNormalMode' : 'startInTestMode';
				vm.$data.loading_doRun = true;
				axios.post(vm.$data.baseUrlWithId + '?action=' + actionName)
					.then(vm.successHandler)
					.catch(vm.errorHandler)
					.then(function() {
						vm.$data.loading_doRun = false;						
					});
			},
			errorHandler: function(err) {
				var data = err.response && err.response.data;
				if (data.message === 'UNKNOWN_USER') {
					this.$notify({
						type: 'error',
						text: 'Требуется авторизация'
					});
				}
				else {
					this.$notify({
						type: 'error',
						text: 'Произошла ошибка'
					});
					console.log(err);
				}
			},
			successHandler: function() {
				this.$notify({
					type: 'success',
					text: 'Успех',
				})
			},			
			____doUpdate: function(){
				throw ('Надо поправить формат данных в spc_mailing_actions.vue чтобы они были в формате который ждёт API mailing-manager')

				var fields = this.$props.record_data.fields; // данные записи какими мы получили их от uarm
				var apiData = {};
				for (var i = 0; i < fields.length; i++) {
					var apiDataKey = snakeToCamel(fields[i].fieldId);
					var apiDataValue = fields[i].value;
					apiData[apiDataKey] = apiDataValue;
				}
				var refdata = { // такие данные ждёт API
					creationDate: "28.02.2017 15:33",
					cronExpression: "0 0/5 * * * *",
					description: "Ежедневный обзор публикаций центральных и региональных СМИ о железнодорожном транспорте↵0 00 16 ? * MON-FRI↵* */15 * * * *↵* 30 * * * *↵",
					id: 26,
					innerReplyEmail: "newslist@rzd.ru",
					innerSubscriptionLink: "http://press.psi.oooinex.ru/smi/public/ru?STRUCTURE_ID=5063&layer_id=5870",
					lastModificationDate: "07.07.2017 13:30",
					lastProcessDate: "25.09.2019 18:50",
					mailThemeTemplate: "Обзоры СМИ",
					mailUrlTemplate: "http://press.psi.oooinex.ru/smi/public/ru?PREV_POST_DATE=#@#LAST_PROCESS_DATE#@#&STRUCTURE_ID=2&layer_id=5865&post_id=26&start_date=#@#CURRENT_PROCESS_DATE#@#&#@#FILTER#@#",
					name: "Обзоры СМИ",
					outerReplyEmail: "newslist@rzd.ru",
					outerSubscriptionLink: "http://press.psi.oooinex.ru/smi/public/ru?STRUCTURE_ID=5063&layer_id=5870",
					publicationType: "ALL",
					status: "ENABLED",
					tag: "Пресс-центр",
					testEmails: ["s_babenkova@mail.ru"], //  ----- это станет дочерним армом?
					topic: "MAILING-MANAGER.MAILING-54",
				}
				var vm = this;
				vm.$data.loading_doUpdate = true;
				console.log(apiData)
				axios.post(vm.$data.baseUrlWithId, apiData)
					.then(vm.successHandler)
					.catch(vm.errorHandler)
					.then(function() {						
						vm.$data.loading_doUpdate = false;
					});
			},
		},
		mounted: function() {},
	}


function snakeToCamel(str) {
	return str.replace(/([-_][a-z])/g, function(group) {
		return group.toUpperCase()
			.replace('-', '')
			.replace('_', '')
	})
}
</script>